// Chakra imports
import { Portal, Box, useDisclosure } from '@chakra-ui/react';
// import Footer from 'components/footer/FooterAdmin.js';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from 'routes.js';
// import ViewOrder from 'views/admin/viewDirectOrder';
// import ViewServiceProvider from 'views/admin/viewServiceProviderDetails';
// import ViewBiddingOrder from 'views/admin/viewBiddingOrder';
// import ViewEmergencyOrder from 'views/admin/viewEmergencyOrder';
// import ViewCreateServiceProvider from 'views/admin/createServiceProvider';
// import ViewCreateSubadmin from 'views/admin/createSubadmin';
// import ViewUser from "views/admin/viewUserDetails";
// import ViewDisputeUser from "views/admin/viewDisputeUserDetails"
// import UserDirectOrder from 'views/admin/userDirectHiring';
// import UserBiddingOrder from 'views/admin/userBiddingHiring';
// import UserEmergencyOrder from 'views/admin/userEmergencyHiring';
import ViewAddBanner from 'views/admin/addBanner';
// Custom Chakra theme
export default function Dashboard(props) {
  const { ...rest } = props;
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };
  const getActiveRoute = (routes) => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    let allRoutes = [];

    routes.forEach((route, key) => {
      if (route.layout === '/admin') {
        allRoutes.push(
          <Route path={`${route.path}`} element={route.component} key={key} />,
        );
      }
      if (route.collapse) {
        allRoutes = allRoutes.concat(getRoutes(route.items));
      }
    });

    // Add custom routes outside the loop
    //   allRoutes.push(
    //     <Route path="/viewOrder/:orderId" element={<ViewOrder />} key="viewOrder" />
    //   );
    // 	allRoutes.push(
    // 		<Route path="/directOrder/:user_id" element={<UserDirectOrder />} key="UserDirectOrder" />
    // 	);
    // 	allRoutes.push(
    // 		// <Route path="/bidding_Order/:user_id" element={<UserBiddingOrder />} key="UserBiddingOrder" />
    // 	);
    // 	allRoutes.push(
    // 		<Route path="/emergency_Order/:user_id" element={<UserEmergencyOrder />} key="UserEmergencyOrder" />
    // 	);
    //   allRoutes.push(
    //     <Route path="/details/:service_provider_id" element={<ViewServiceProvider />} key="viewServiceProvider" />
    //   );
    // 	allRoutes.push(
    //     <Route path="/UserDetails/:user_id" element={<ViewUser />} key="viewUser" />
    //   );
    // 	allRoutes.push(
    //     <Route path="/Dispute/UserDetails/:user_id" element={<ViewDisputeUser />} key="viewDisputeUser" />
    //   );
    //   allRoutes.push(
    //     <Route path="/biddingOrder/:orderId" element={<ViewBiddingOrder />} key="viewBiddingOrder" />
    //   );
    // 	allRoutes.push(
    //     <Route path="/emergencyOrder/:orderId" element={<ViewEmergencyOrder />} key="viewEmergencyOrder" />
    //   );
    // 	allRoutes.push(
    //     <Route path="/createServiceProvider" element={<ViewCreateServiceProvider />} key="viewCreateServiceProvider" />
    //   );
    // allRoutes.push(
    //     <Route path="/createSubadmin" element={<ViewCreateSubadmin />} key="ViewCreateSubadmin" />
    //   );
    allRoutes.push(
      <Route
        path="/addBanner"
        element={<ViewAddBanner />}
        key="ViewCreateBanner"
      />,
    );
    return allRoutes;
  };
  document.documentElement.dir = 'ltr';
  const { onOpen } = useDisclosure();
  document.documentElement.dir = 'ltr';
  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar routes={routes} display="none" {...rest} />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={'Horizon UI Dashboard PRO'}
                  // brandText={getActiveRoute(routes)}
                  secondary={getActiveNavbar(routes)}
                  message={getActiveNavbarText(routes)}
                  fixed={fixed}
                  {...rest}
                />
              </Box>
            </Portal>

            {getRoute() ? (
              <Box
                mx="auto"
                p={{ base: '20px', md: '30px' }}
                pe="20px"
                minH="100vh"
                pt="50px"
              >
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to="/admin/dashboard" replace />}
                  />
                </Routes>
              </Box>
            ) : null}
            <Box></Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
}
